import "swiper/css";
import "swiper/css/a11y";
import "swiper/css/keyboard";

import * as React from "react";
import { useIntl } from "react-intl";
import { A11y, Keyboard } from "swiper";
import { Swiper, SwiperProps } from "swiper/react";

export const BasicSwiper = ({ children, modules = [], ...restProps }: SwiperProps) => {
    const intl = useIntl();
    return (
        <Swiper
            a11y={{
                firstSlideMessage: intl.formatMessage({
                    defaultMessage: "Das ist der erste Eintrag",
                    id: "swiper.prevButton.firstSlide.ariaLabel",
                }),
                lastSlideMessage: intl.formatMessage({
                    defaultMessage: "Das ist der letzte Eintrag",
                    id: "swiper.nextButton.lastSlide.ariaLabel",
                }),
                nextSlideMessage: intl.formatMessage({ defaultMessage: "Nächster Eintrag", id: "swiper.nextButton.ariaLabel" }),
                paginationBulletMessage: intl.formatMessage(
                    {
                        defaultMessage: "Gehe zu Eintrag {index}",
                        id: "swiper.paginationBullet.ariaLabel",
                    },
                    { index: "{{index}}" }, // Swiper replaces {{index}} with the actual index
                ),
                prevSlideMessage: intl.formatMessage({ defaultMessage: "Vorheriger Eintrag", id: "swiper.prevButton.ariaLabel" }),
            }}
            keyboard={{ enabled: true }}
            modules={[...modules, A11y, Keyboard]}
            {...restProps}
        >
            {children}
        </Swiper>
    );
};
